export enum UserDetailsIcons {
    USER = "user",
    AGE = "age",
    PERMISSIONS = "permissions",
    ROLE = "role",
}
